// src/pages/Historico/components/SpectralChartSection.jsx
import React from 'react';
import { Box, Typography, Skeleton, useTheme, useMediaQuery } from '@mui/material';
import ColorTimelineChart from '../../../components/ColorTimelineChart';
import ChartCard from '../../../components/ChartCard';
import ChartSkeleton from '../../../components/ChartSkeleton';
import SpectrogramChart from '../../../components/SpectrogramChart';

export default function SpectralChartSection({
    activeTab,
    chartData,
    error,
    errorCode,
    onRetry,
    sensorType,
    turbidimetryChart,
    experiment,
    activeLabel,
    loading,
    isSpectral,
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {isSpectral && (
                    <Box sx={{ order: { xs: 2, md: 1 } }}>
                        <Skeleton variant="text" width="30%" sx={{ margin: '0 auto 16px' }} />
                        <ChartSkeleton height={isMobile ? 150 : 200} />
                    </Box>
                )}
                <Box sx={{ order: { xs: 1, md: 2 } }}>
                    <ChartSkeleton height={isMobile ? 340 : 480} />
                </Box>
                {isSpectral && (
                    <Box sx={{ order: { xs: 3, md: 3 } }}>
                        <Skeleton variant="text" width="30%" sx={{ margin: '0 auto 16px' }} />
                        <ChartSkeleton height={isMobile ? 240 : 300} />
                    </Box>
                )}
            </Box>
        );
    }

    const tituloSecao = {
        textAlign: 'center',
        mb: 1,
        fontSize: isMobile ? '0.95rem' : '1.25rem',
        fontWeight: 700,
    };

    return (
        // No celular o grafico de series vem PRIMEIRO: e o que o usuario abriu a tela
        // para ver. "Cor x Tempo" e ilustrativo e continua acima no desktop, onde os
        // tres cabem juntos sem custo de rolagem.
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Cor x Tempo — só para tabs spectrais com dados */}
            {isSpectral && chartData && (
                <Box sx={{ order: { xs: 2, md: 1 } }}>
                    <Typography variant="h6" sx={tituloSecao}>
                        Cor x Tempo
                    </Typography>
                    <ColorTimelineChart chart={chartData} />
                </Box>
            )}

            {/* Gráfico de séries (todas as tabs) */}
            <Box sx={{ order: { xs: 1, md: 2 } }}>
                <ChartCard
                    title={activeLabel}
                    data={chartData}
                    error={error}
                    errorCode={errorCode}
                    onRetry={onRetry}
                    sensorType={sensorType}
                    graficoTipo={activeTab}
                />
            </Box>

            {/* Espectrograma — só para tabs spectrais com dados */}
            {isSpectral && chartData && (
                <Box sx={{ order: { xs: 3, md: 3 } }}>
                    <Typography variant="h6" sx={tituloSecao}>
                        Espectro x Tempo
                    </Typography>
                    <SpectrogramChart chart={chartData} sensorType={sensorType} />
                </Box>
            )}
        </Box>
    );
}
